import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ImportFileLoadRowResult } from '../../shared/file-import/import-file-load-row-result';
import { TranslateService } from '@ngx-translate/core';
import { ImportFileLoadsColumn, ImportFileLoadsColumnType } from '../../shared/file-import/import-file-loads-column';
import { ModalService } from '../../../shared/services/modal.service';

interface ColumnValue {
  column: ImportFileLoadsColumn;
  hasError: boolean;
  errorMessageKey: string;
  collapsed: boolean;
  showCollapsButton: boolean;
}

@Component({
  selector: 'app-row-result',
  templateUrl: './row-result.component.html',
  styleUrls: ['./row-result.component.scss']
})
export class RowResultComponent implements OnInit, OnChanges {

  @Input()
  row: ImportFileLoadRowResult;

  @Input()
  columns: ImportFileLoadsColumn[] = [];

  valuesShown = false;

  columnsValue: ColumnValue[] = [];

  ColumnsTypes = ImportFileLoadsColumnType;

  constructor(private translate: TranslateService, private modalService: ModalService) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.row) {
      if (this.row.failed) {
        this.showValues();
      }
    }
  }

  showValues() {
    this.updateColumnsValues();
    this.valuesShown = true;
  }

  hideValues() {
    this.valuesShown = false;
  }

  showCollapsedColumns(column: ColumnValue) {
    column.collapsed = false;

    const index = this.columnsValue.indexOf(column);
    let cpt     = 1;

    for (let i = index; i < this.columnsValue.length; i++) {
      const c = this.columnsValue[i];

      if (c.hasError) {
        break;
      }

      c.collapsed = false;

      if (cpt >= 7) {
        if (i < this.columnsValue.length - 1 && this.columnsValue[i + 1]) {
          this.columnsValue[i + 1].showCollapsButton = true;
        }

        break;
      }

      cpt++;
    }
  }

  showColumnErrorDetail(content, columnValue: ColumnValue) {
    this.modalService.open({
      title: this.translate.instant('local-loads.import.file.row.modals.column-error-details.title'),
      data: { columnValue },
      content,
      validateButton: {
        displayed: false,
        text: null
      }
    })
  }

  private updateColumnsValues() {
    this.columnsValue = [];

    for (let i = 0; i < this.columns.length; i++) {
      const column          = this.columns[i];
      const hasError        = this.hasColumnAnyError(column);
      const errorMessageKey = this.getColumnErrorMessageKey(column);

      const collapsed = !hasError;

      let showCollapsButton = false;

      if (this.row.failed) {
        if (i === 0) {
          showCollapsButton = true;
        } else if (this.columnsValue[i - 1].hasError) {
          showCollapsButton = true;
        }
      }


      this.columnsValue.push({
        column: column,
        hasError: hasError,
        errorMessageKey: errorMessageKey,
        collapsed: collapsed,
        showCollapsButton: showCollapsButton
      });
    }
  }

  private hasColumnAnyError(column: ImportFileLoadsColumn) {
    if (this.row.parseErrors.length > 0 && this.row.parseErrors.findIndex(e => e.fieldName === column.name) !== -1) {
      return true;
    }

    if (this.row.validationErrors.length > 0 && this.row.validationErrors.findIndex(e => e.fieldName === column.name) !== -1) {
      return true;
    }

    return false;
  }

  private getColumnErrorMessageKey(column: ImportFileLoadsColumn): string {
    const parseError      = this.row.parseErrors.find(e => e.fieldName === column.name);
    const validationError = this.row.validationErrors.find(e => e.fieldName === column.name);

    if (parseError) {
      return `local-loads.import.file.errors.parse`;
    } else if (validationError) {
      return `local-loads.import.file.errors.validation.${validationError.type}`;
    }

    return null;
  }

}
